import React from 'react'
import { type SwitchProps, type SxProps, type Theme } from '@mui/material'

import SelectionCard from './SelectionCard'

export interface SwitchCardProps {
  icon?: React.ReactNode
  label?: string
  description?: string
  cardSx?: SxProps<Theme>
  disabled?: boolean
  controlProps?: Omit<SwitchProps, 'disabled'>
}

const SwitchCard: React.FC<SwitchCardProps> = ({
  icon,
  label,
  description,
  cardSx,
  disabled,
  controlProps,
}) => {
  return (
    <SelectionCard
      controlType='switch'
      icon={icon}
      label={label}
      description={description}
      cardSx={cardSx}
      disabled={disabled}
      controlProps={controlProps}
    />
  )
}

export default SwitchCard
